import createReactComponent from '../createReactComponent';
var MousePointer = createReactComponent('MousePointer', [['path', {
  d: 'M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z',
  key: 'ncj19w'
}], ['path', {
  d: 'M13 13l6 6',
  key: '1kuiyj'
}]]);
export default MousePointer;